import { createActionGroup, props } from '@ngrx/store';
import { FEATURE_NAME } from './pipeline-retrigger-dialog.constant';

export const pipelineRetriggerDialogActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    'open': props<{ id: string; }>()
  }
});
